import React from 'react';
import { Calendar } from 'lucide-react';
import { imageData, getAltText } from '../../data/images';

const HeroSection = ({ 
  language, 
  currentContent, 
  currentImageIndex, 
  scrollToSection 
}) => {
  const { heroImages } = imageData;

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image Carousel */}
      <div className="absolute inset-0">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image.src}
              alt={getAltText(image, language)}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/50"></div>
          </div>
        ))}
      </div>

      {/* Hero Content */}
      <div className="relative z-10 text-center text-white px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold mb-4 animate-fadeInUp font-dancing">
          {currentContent.hero.title}
        </h1>
        <p className="text-xl sm:text-2xl md:text-3xl mb-6 animate-fadeInUp animation-delay-200 font-light">
          {currentContent.hero.subtitle}
        </p>
        <p className="text-lg sm:text-xl mb-8 max-w-2xl mx-auto animate-fadeInUp animation-delay-400">
          {currentContent.hero.description}
        </p>
        <button
          onClick={() => scrollToSection('booking')}
          className="btn-tilcara text-lg px-8 py-4 animate-fadeInUp animation-delay-600 inline-flex items-center space-x-2"
        >
          <Calendar className="h-5 w-5" />
          <span>{currentContent.hero.cta}</span>
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
